import { Typography } from "../../../designComponents";

type License = {
  licenseName: string;
  licenseNumber: string;
  issuingAuthority: string;
  expiryDate: string;
  img: string[];
};

type Certification = {
  name: string;
  issuer: string;
  year: string;
  pdf: string[];
};

type Props = {
  licenses?: License[];
  certifications?: Certification[];
};

const LicensesAndCertificationsView = ({
  licenses = [],
  certifications = [],
}: Props) => {
  return (
    <div style={{ width: "100%" }}>
      {/* Licenses */}
      <div style={{ marginBottom: 40 }}>
        <Typography
          style={{ marginTop: 10, marginBottom: 20 }}
          variant="normal"
          strong
          fontColor="secondary"
          className="section-title"
        >
          Licenses
        </Typography>

        {licenses.length ? (
          licenses.map((license, idx) => (
            <div
              key={idx}
              style={{
                border: "1px solid #ddd",
                borderRadius: 8,
                padding: 16,
                marginBottom: 16,
              }}
            >
              <Typography strong>{license.licenseName}</Typography>
              <Typography>License Number: {license.licenseNumber}</Typography>
              <Typography>
                Issuing Authority: {license.issuingAuthority}
              </Typography>
              <Typography>
                Expiry Date:{" "}
                {license.expiryDate
                  ? new Date(license.expiryDate).toLocaleDateString()
                  : "—"}
              </Typography>

              {license.img?.length > 0 && (
                <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
                  {license.img.map((file, i) => (
                    <a
                      key={i}
                      href={file}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={file}
                        alt={`license-${i}`}
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 4,
                          border: "1px solid #ccc",
                        }}
                        onError={(e: any) => {
                          e.target.src = "/assets/icons/file-icon.png";
                        }}
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))
        ) : (
          <Typography>No licenses available.</Typography>
        )}
      </div>

      {/* Certifications */}
      <div>
        <Typography
          style={{ marginTop: 10, marginBottom: 20 }}
          variant="normal"
          strong
          fontColor="secondary"
          className="section-title"
        >
          Certifications
        </Typography>

        {certifications.length ? (
          certifications.map((cert, idx) => (
            <div
              key={idx}
              style={{
                border: "1px solid #ddd",
                borderRadius: 8,
                padding: 16,
                marginBottom: 16,
              }}
            >
              <Typography strong>{cert.name}</Typography>
              <Typography>Issuer: {cert.issuer}</Typography>
              <Typography>Year: {cert.year}</Typography>

              {cert.pdf?.length > 0 && (
                <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
                  {cert.pdf.map((file, i) => (
                    <a
                      key={i}
                      href={file}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/assets/icons/file-icon.png"
                        alt={`cert-${i}`}
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "contain",
                          borderRadius: 4,
                          border: "1px solid #ccc",
                        }}
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))
        ) : (
          <Typography>No certifications available.</Typography>
        )}
      </div>
    </div>
  );
};

export default LicensesAndCertificationsView;
